module.exports = __webpack_public_path__ + "static/3A841E_4_0-033830e03e10154fa9f46d12e4b9e8fa.woff2";